/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface LatestPaymentResponse
 */
export interface LatestPaymentResponse {
    /**
     * 
     * @type {LatestPaymentResponseLatestEventCodeEnum}
     * @memberof LatestPaymentResponse
     */
    latestEventCode: LatestPaymentResponseLatestEventCodeEnum;
    /**
     * 
     * @type {PaymentState}
     * @memberof LatestPaymentResponse
     */
    latestState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof LatestPaymentResponse
     */
    paymentReference: string;
}


/**
 * @export
 */
export const LatestPaymentResponseLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type LatestPaymentResponseLatestEventCodeEnum = typeof LatestPaymentResponseLatestEventCodeEnum[keyof typeof LatestPaymentResponseLatestEventCodeEnum];


/**
 * Check if a given object implements the LatestPaymentResponse interface.
 */
export function instanceOfLatestPaymentResponse(value: object): value is LatestPaymentResponse {
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    return true;
}

export function LatestPaymentResponseFromJSON(json: any): LatestPaymentResponse {
    return LatestPaymentResponseFromJSONTyped(json, false);
}

export function LatestPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'latestEventCode': json['latestEventCode'],
        'latestState': PaymentStateFromJSON(json['latestState']),
        'paymentReference': json['paymentReference'],
    };
}

export function LatestPaymentResponseToJSON(json: any): LatestPaymentResponse {
    return LatestPaymentResponseToJSONTyped(json, false);
}

export function LatestPaymentResponseToJSONTyped(value?: LatestPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latestEventCode': value['latestEventCode'],
        'latestState': PaymentStateToJSON(value['latestState']),
        'paymentReference': value['paymentReference'],
    };
}

